<template ref="uploadImage">
    <div class="finish_room">
        <div class="finish_room2">
            <!-- <div :images="photo">
                <div :key="index" v-for="(item, index) in photo" class="room_img">
                    <img v-lazy="typeof item == 'string' ? item : item" />
                    <div v-if="!disabled" @click="deleteImg(index)" class="im-button">
                        <div class="im-close"></div>
                        <div class="im-close1"></div>
                    </div>
                </div>
            </div> -->
            <div v-loading="loading" class="room_add_img">
                <el-button type="primary" @click="add_map" size="mini">选择地址</el-button>
            </div>
            <div v-if="photo.name">名称：{{photo.name}}</div>
            <div v-if="photo.address">地址：{{photo.address}}</div>
            <div v-if="photo.lat">经度：{{photo.lng}}</div>
            <div v-if="photo.lng">纬度：{{photo.lat}}</div>
        </div>
        <ele-map-picker :show.sync="map_status" v-on:done="mapReturn"></ele-map-picker>
    </div>
</template>

<script>
    import EleMapPicker from '@/components/EleMapPicker'
    // import axios from "axios";
    export default {
        name: "EleUploadMap",
        props: {
            value: {
                type: [String, Array, File, Blob,Object],
                default () {
                    return '';
                },
            },
        },
        components: {
            EleMapPicker
        },
        data: function() {
            return {
                photo: '',
                loading: false,
                map_status:false,
                
            };
        },
        watch: {
            photo() {
                // if (this.photo.length > 0) {
                    // if (this.limit == 1) {
                    //     this.$emit("input", this.photo[0]);
                    // } else {
                        this.$emit("input", this.photo);
                    // }
                // }
            },
            value: {
                immediate: true,
                handler: function() {
                    this.photo = this.value||{};
                    if (typeof this.value == "string") {
                        if (this.value == "") {
                            this.photo = [];
                        } else {
                            this.photo = [this.value];
                        }
                    } else if (this.value instanceof Array) {
                        this.photo = this.value;
                    } else {
                        try {
                            let fileReader = new FileReader();
                            fileReader.readAsDataURL(this.value);
                            fileReader.onload = (e) => {
                                this.photo = [e.target.result];
                            };
                        } catch (e) {
                            console.log(e.message)
                        }
                    }
                },
            },
        },
        methods: {
            /* 地图选择返回数据*/
            mapReturn(e) {
                this.photo = e;
                this.map_status = false;
            },
            add_map(){
                this.map_status = true;
            },
            
        },
    };
</script>
<style>
    .finish_room {
        /*width: 140px;*/
        /*height: 165px;*/
    }

    img {
        height: 100%;
    }

    .finish_room2 {
        width: 100%;
        height: 100%;
        /* display: flex;
        align-items: center;
        flex-flow: wrap; */
    }

    .finish_room2>div {
        display: flex;
        flex-wrap: wrap;
    }

    .finish_room2 .margeImg {
        margin-left: 10px;
    }

    .finish_room2 .room_img {
        width: 100px;
        height: 100px;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.5);
        margin-left: 10px;
        margin-top: 10px;
    }

    .finish_room2 .room_img:before {
        /*content: "";*/
        /*width: 0;*/
        /*height: 100%;*/
        /*!*background: #000;*!*/
        /*padding: 14px 18px;*/
        /*position: absolute;*/
        /*top: 0;*/
        /*left: 50%;*/
        /*opacity: 0;*/
    }

    .finish_room2 .room_img:hover:before {
        width: 100%;
        left: 0;
        opacity: 0.5;
    }

    .finish_room2 .room_img .box-content {
        width: 100%;
        padding: 14px 18px;
        color: #fff;
        position: absolute;
        top: 38%;
        left: 0;
    }

    .finish_room2 .room_img .icon {
        padding: 0;
        margin: 0;
        list-style: none;
        margin-top: -20px;
    }

    .finish_room2 .room_img .icon li {
        display: inline-block;
    }

    .finish_room2 .room_img .icon li i {
        display: block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 50%;
        font-size: 20px;
        font-weight: 700;
        color: #fff;
        margin-right: 25px;
        opacity: 0;
        transform: translateY(50px);
        transition: all 0.5s ease 0s;
    }

    @media only screen and (max-width: 990px) {
        .finish_room2 .room_img {}
    }

    .finish_room2 .deleteImg {
        color: red;
        position: absolute;
        top: 0px;
        left: 80px;
        cursor: pointer;
    }

    .finish_room2 .room_img img {
        cursor: pointer;
        width: 100px;
        height: 100px;
    }

    .finish_room2>.room_img span {
        position: absolute;
        width: auto;
        height: auto;
        right: 5px;
        bottom: 3px;
    }

    .finish_room2 .im-button {
        position: absolute;
        top: -14px;
        right: -18px;
        width: 40px;
        height: 40px;
        cursor: pointer;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.5);
        opacity: 0;
    }

    .finish_room2 .room_img:hover .icon li i {
        opacity: 0.5;
    }

    .finish_room2 .room_img:hover img {
        opacity: 0.5;
    }

    .finish_room2 .room_img:hover .im-button {
        opacity: 1;
    }

    .finish_room2 .im-close {
        transform: rotate(-45deg);
        line-height: 0px;
        left: 6px;
        bottom: 13px;
        display: inline-block;
        width: 15px;
        height: 2px;
        background: #fff;
        position: absolute;
    }

    .finish_room2 .im-close1 {
        left: 5px;
        bottom: 13px;
        display: inline-block;
        width: 15px;
        height: 2px;
        background: #fff;
        position: absolute;
        transform: rotate(45deg);
    }


    
</style>
